// extracted by mini-css-extract-plugin
module.exports = {"headingField":"TimeWrapper_headingField__lPGqh","error":"TimeWrapper_error__1omRU","date":"TimeWrapper_date__1gYxa"};